"use client";

import { addNextjsError } from "@datadog/browser-rum-nextjs";
import { useEffect } from "react";

/**
 * 루트 레이아웃 수준의 미처리 예외 폴백 (SD-7923).
 *
 * 활성화되면 루트 레이아웃(`[lang]/layout.tsx`)을 통째로 대체하므로 자체 <html>/<body> 와
 * 인라인 스타일을 갖는다 — globals.css/폰트 파이프라인에 의존하지 않는다. i18n 라우팅이어도
 * global-error 는 app 루트(`src/app/global-error.tsx`)에 둔다(Next.js 문서).
 *
 * Client Component 라 metadata export 불가 → React <title> 사용. Datadog RUM 으로 에러 리포트.
 */
export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    addNextjsError(error);
  }, [error]);

  return (
    <html lang="ko">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
          padding: "24px",
          textAlign: "center",
          fontFamily:
            "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
          color: "#111827",
          background: "#ffffff",
        }}
      >
        <title>오류가 발생했습니다 - GOLFFIX</title>
        <h1 style={{ fontSize: "20px", fontWeight: 700, margin: 0 }}>
          문제가 발생했습니다
        </h1>
        <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
          잠시 후 다시 시도해 주세요. 문제가 계속되면 고객센터로 문의해 주세요.
        </p>
        <button
          type="button"
          onClick={() => unstable_retry()}
          style={{
            marginTop: "8px",
            borderRadius: "8px",
            border: "none",
            background: "#1b61c9",
            color: "#ffffff",
            fontSize: "14px",
            fontWeight: 600,
            padding: "10px 20px",
            cursor: "pointer",
          }}
        >
          다시 시도
        </button>
      </body>
    </html>
  );
}
